import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Spinner } from '@nvision/ui';

import { TabsLayout } from '@/components/tabs-layout';

import { LazyAccessorial } from './components/accessorial/accessorial.lazy';
import { LazyAccessorials } from './components/accessorials/accessorials.lazy';
import { LazyPricings } from './components/pricings/pricings.lazy';
import { LazyTariffDetails } from './components/tariff/tariff-details.lazy';
import { LazyTariffs } from './components/tariffs/tariffs.lazy';
import { ROUTES } from './config';

const TABS = [
  { label: 'Pricings', to: ROUTES.pricing() },
  { label: 'Tariffs', to: ROUTES.tariffs() },
  { label: 'Accessorials', to: ROUTES.accessorials() },
];

export const routes = {
  root: {
    Component: () => (
      <TabsLayout tabs={TABS}>
        <Suspense fallback={<Spinner size="sm" />}>
          <Outlet />
        </Suspense>
      </TabsLayout>
    ),
    path: ROUTES.root(),
  },
  routes: [
    {
      Component: () => <LazyPricings />,
      path: ROUTES.pricing(),
    },
    {
      Component: () => (
        <>
          <LazyTariffs />
          <Outlet />
        </>
      ),
      path: ROUTES.tariffs(),
    },
    {
      Component: () => <LazyTariffDetails />,
      path: ROUTES.tariff(),
    },
    {
      Component: () => <LazyAccessorials />,
      path: ROUTES.accessorials(),
    },
    {
      Component: () => <LazyAccessorial />,
      path: ROUTES.accessorial(),
    },
  ],
};
